<template>
  <div class="mb-2 facethierarchy" v-if="hierarchy">
  <label class="facetlabel">{{$t('scifund.labels.'+facetname)}}</label>
  <treeselect
    :multiple="true"
    :options="options"
    @select="facetChanged"
    @deselect="facetChanged"
    placeholder="Search or select"
    :always-open="false"
    openDirection="bottom"
    v-model="value"
    value-consists-of="BRANCH_PRIORITY"
    :maxHeight="200"
  />
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'

export default {
  name: 'facethierarchy',
  props: [ 'facetname' ],
  data: () => ({
    value: [],
    options: []
  }),
  created: function () {
    if (this.hierarchy) {
      this.refreshTreeselect(this.hierarchy);
    }
  },
  components: {
    Treeselect
  },
  watch: {
    hierarchy: function (newFacet) {
      this.refreshTreeselect(newFacet);
    }
  },
  methods: {
    facetChanged: function (item) {
      this.value=[];
      this.$router.push(item.action);
    },
    refreshTreeselect: function (newFacet) {
      this.options = [];
      this.value = [];
      for (var item in newFacet) {
        var idLevel1 = ('' + newFacet[item].value).hashCode()
        var newItem = {
          id: idLevel1,
          label: item + ' (' + newFacet[item].count + ')',
          action: newFacet[item].sem_action.sem_url_action
        }
        newItem.children = [];
        for (var item2 in newFacet[item].options) {
          var idLevel2 = ('' + newFacet[item].value + newFacet[item].options[item2].value).hashCode();
          var newItem2 = {
            id: idLevel2,
            label: item2 + ' (' + newFacet[item].options[item2].count + ')',
            action: newFacet[item].options[item2].sem_action.sem_url_action
          }
          newItem2.children = [];
          for (var item3 in newFacet[item].options[item2].options) {
            var idLevel3 = ('' + newFacet[item].value + newFacet[item].options[item2].value + newFacet[item].options[item2].options[item3].value).hashCode()
            var newItem3 = {
              id:  idLevel3,
              label: item3 + ' (' + newFacet[item].options[item2].options[item3].count + ')',
              action: newFacet[item].options[item2].options[item3].sem_action.sem_url_action
            }
            newItem2.children.push(newItem3);
            if (newFacet[item].options[item2].options[item3].active) {
              this.value.push(newItem3.id);
            }
          }
          if( newItem2.children && newItem2.children.length < 1 )
            newItem2.children = '';
          newItem.children.push(newItem2);
          if (newFacet[item].options[item2].active) {
            this.value.push(newItem2.id);
          }
        }
        if( newItem.children && newItem.children.length < 1 )
          newItem.children = '';
        this.options.push(newItem);
        if (newFacet[item].active) {
          this.value.push(newItem.id);
        }
      }
    }
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    hierarchy () {
      if (this.$store.state.response &&
        this.$store.state.response.facet_counts &&
        this.$store.state.response.facet_counts.facet_hierarchies ) {
          return this.$store.state.response.facet_counts.facet_hierarchies.Programme_Divisions_Alt;
      }
      return  null;
    },
  }
}
</script>

<style scoped>
.facetlabel {
  font-size: 14px;
  color: #888;
  font-weight: 700;
}
</style>
